<template>
  <div class="h-100">

    <div class="card">
      <div class="card-body p-0">
        <v-server-table
          ref="activityTable"
          :columns="columns"
          :options="options"
          :url="tableUrl"
        >
          <!-- ── Filters injected into the table toolbar ── -->
          <div slot="beforeTable" class="row align-items-center px-1 w-100 m-0 py-1 flex-wrap">

            <!-- Causer (User) -->
            <div class="col-md-2 mb-1">
              <CustomMutliSelect
                v-model="activeFilters.causer"
                label="name"
                @select="applyFilters"
                track-by="value"
                :options="orgUsers"
                :searchable="false"
                :close-on-select="false"
                :show-labels="true"
                :allow-empty="true"
                selectLabel=""
                deselectLabel=""
                selectedLabel=""
                placeholder="Օգտատեր"
              />
            </div>


            <!-- Date From -->
            <div class="col-auto mb-1">
              <input
                v-model="activeFilters.date_from"
                type="date"
                class="form-control form-control-sm"
                @change="applyFilters"
              />
            </div>

            <!-- Date To -->
            <div class="col-auto mb-1">
              <input
                v-model="activeFilters.date_to"
                type="date"
                class="form-control form-control-sm"
                @change="applyFilters"
              />
            </div>

          </div>

          <!-- ── Column: causer ── -->
          <div slot="causer" slot-scope="{ row }" class="d-flex flex-column justify-content-center h-100">
            <template v-if="row.causer">
              <span class="font-weight-medium">{{ row.causer.username }}</span>
              <small class="text-muted">{{ row.causer.email }}</small>
            </template>
            <span v-else class="text-muted">—</span>
          </div>

          <!-- ── Column: event ── -->
          <div slot="event" slot-scope="{ row }" class="d-flex align-items-center h-100">
            <span class="badge" :class="eventBadgeClass(row.event)">
              {{ eventLabel(row.event) }}
            </span>
          </div>

          <!-- ── Column: subject ── -->
          <div slot="subject" slot-scope="{ row }" class="d-flex align-items-center h-100">
            <template v-if="row.subject">
              <span class="text-primary font-weight-medium">{{ row.subject.type }}</span>
              <small class="text-muted ml-1">#{{ row.subject.id }}</small>
            </template>
            <span v-else class="text-muted">—</span>
          </div>

          <!-- ── Column: changes ── -->
          <div slot="changes" slot-scope="{ row }" class="h-100 py-1" style="max-width:340px">
            <template v-if="row.changes && row.changes.length">
              <div
                v-for="(change, idx) in row.changes"
                :key="idx"
                class="activity-change-row"
                :class="{ 'mt-1': idx > 0 }"
              >
                <span class="activity-field-badge">{{ change.field }}</span>
                <span class="activity-old-val" :title="change.old_value">{{ change.old_value || '—' }}</span>
                <svg class="activity-arrow" width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M1 5h8M6 2l3 3-3 3" stroke="#6E7485" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="activity-new-val" :title="change.new_value">{{ change.new_value || '—' }}</span>
              </div>
            </template>
            <span v-else class="text-muted">—</span>
          </div>

          <!-- ── Column: changed_at ── -->
          <div slot="changed_at" slot-scope="{ row }" class="d-flex align-items-center h-100" style="white-space:nowrap">
            <small>{{ formatDate(row.changed_at) }}</small>
          </div>

        </v-server-table>
      </div>
    </div>
  </div>
</template>

<script>
import isMobile from '@/mixins/isMobileView'
import CustomMutliSelect from "@/components/helpers/CustomMutliSelect.vue";

export default {
  name: 'ActivityLog',
  components: {CustomMutliSelect},
  mixins: [isMobile],

  data() {
    const self = this
    return {
      tableUrl: `${process.env.VUE_APP_API_URL}history/activity-log`,

      orgUsers: [],

      activeFilters: {
        causer:    '',
        date_from:    '',
        date_to:      '',
      },
      columns: ['id', 'causer', 'event', 'subject', 'changes', 'changed_at'],

      options: {
        perPageValues: [5, 10, 25, 50, 100],
        perPage: 10,
        sortable: [],
        columnsDropdown: false,
        filterByColumn: false,
        skin: 'table',
        pagination: { chunk: 1 },
        headings: {
          id:         '#',
          causer:     'Կատարողը',
          event:      'Գործողություն',
          subject:    'Օբյեկտ',
          changes:    'Փոփոխություններ',
          changed_at: 'Ամսաթիվ',
        },

        customFilters: [
          'causer_id',
          'date_from',
          'date_to',
        ],

        requestFunction(params) {
          return this.$client
            .get(this.url, { params })
            .then(response => {
              const body = response.data

              // Populate user filter list the first time (or on every load)
              if (body.org_users && body.org_users.length) {
                self.orgUsers = body.org_users.map(u => ({
                  ...u,
                  name: `${u.username} (${u.email})`,
                  value: u.id
                }));
              }

              return {
                data: {
                  data:  body.data  || [],
                  count: body.count || 0,
                },
              }
            })
            .catch(function (e) {
              this.dispatch('error', e)
            })
        },
      },
    }
  },

  methods: {
    applyFilters() {
      console.log(this.activeFilters)
      this.$refs.activityTable.setCustomFilters({
        causer_id:    this.activeFilters.causer.id    || undefined,
        date_from:    this.activeFilters.date_from     || undefined,
        date_to:      this.activeFilters.date_to       || undefined,
      })
    },
    eventLabel(event) {
      return { created: 'Ստեղծված', updated: 'Թարմ.', deleted: 'Ջնջված' }[event] || event
    },
    eventBadgeClass(event) {
      return {
        'badge-success':   event === 'created',
        'badge-warning':   event === 'updated',
        'badge-danger':    event === 'deleted',
        'badge-secondary': !['created', 'updated', 'deleted'].includes(event),
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '—'
      const d = new Date(dateStr.replace(' ', 'T'))
      if (isNaN(d)) return dateStr
      const p = n => String(n).padStart(2, '0')
      return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
  },
}
</script>

<style scoped>
.activity-change-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 0.73rem;
  line-height: 1.3;
}

.activity-field-badge {
  background: #e9ecef;
  color: #495057;
  border-radius: 3px;
  padding: 1px 5px;
  font-size: 0.68rem;
  font-weight: 600;
}

.activity-old-val {
  color: #6c757d;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}

.activity-new-val {
  color: #006BE6;
  font-weight: 500;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}

.activity-arrow {
  flex-shrink: 0;
}

.font-weight-medium {
  font-weight: 500;
}
.table-filters {
  padding: 20px;
}
</style>
